import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorityService {
  private readonly authService = inject(AuthService);

  async hasScopes(requiredScopeGroups: string[]): Promise<boolean> {
    const userScopes: string[] = await this.authService.getScopes();

    return requiredScopeGroups.some((scope) => userScopes.includes(scope));
  }
}
